export const TOGGLE_ASK_GEOLOCATION_PANEL = 'TOGGLE_ASK_GEOLOCATION_PANEL'

export function displayAskGeolocationPanelReducer (state = false, action) {
    switch (action.type){
        case TOGGLE_ASK_GEOLOCATION_PANEL:
            return action.payload
        default: return state
    }
}